import PropTypes from 'prop-types'

const propTypes = {
  classes: PropTypes.object.isRequired,
  completeHandler: PropTypes.func,
  entity: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  onDrag: PropTypes.func,
  back: PropTypes.func,
  onClick: PropTypes.func,
  cardCount: PropTypes.number,
}

export default propTypes
